(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupGalleryNextButtons = (root = document) => {
      root.querySelectorAll('[data-pizzannu-gallery-next]').forEach((button) => {
        if (button.dataset.galleryNextReady === 'true') return;
        button.dataset.galleryNextReady = 'true';

        const carousel = button.closest('carousel-slider');
        const slider = carousel?.querySelector('.slider');
        const grid = carousel?.querySelector('.slider__grid');
        if (!slider || !grid) return;

        const updateButton = () => {
          const hasOverflow = slider.scrollWidth > slider.clientWidth + 8;
          if (!hasOverflow) {
            // Keep the hint visible until the image/layout dimensions are ready.
            button.hidden = false;
            return;
          }

          const isAtEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 8;
          button.hidden = isAtEnd;
        };

        button.addEventListener('click', () => {
          const firstSlide = grid.querySelector('.slider__item:not([hidden])');
          if (!firstSlide) return;

          const gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
          const scrollDistance = firstSlide.getBoundingClientRect().width + gap;
          const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
          slider.scrollTo({
            left: Math.min(slider.scrollLeft + scrollDistance, maxScrollLeft),
            behavior: 'smooth'
          });
        });

        slider.addEventListener('scroll', updateButton, { passive: true });
        window.addEventListener('on:debounced-resize', updateButton);
        if (document.readyState === 'complete') {
          window.requestAnimationFrame(updateButton);
        } else {
          window.addEventListener('load', updateButton, { once: true });
        }
        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(updateButton);
          resizeObserver.observe(slider);
          resizeObserver.observe(grid);
        }
        grid.querySelectorAll('img').forEach((image) => {
          image.addEventListener('load', updateButton, { once: true });
        });
        window.requestAnimationFrame(updateButton);
        updateButton();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupGalleryNextButtons(), { once: true });
    } else {
      setupGalleryNextButtons();
    }
    document.addEventListener('shopify:section:load', (event) => setupGalleryNextButtons(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pizzannu-anniversary-community"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-panniversary-countdown]').forEach((countdown) => {
    const target = new Date(countdown.dataset.target).getTime();
    const values = {
      days: countdown.querySelector('[data-panniversary-days]'),
      hours: countdown.querySelector('[data-panniversary-hours]'),
      minutes: countdown.querySelector('[data-panniversary-minutes]'),
      seconds: countdown.querySelector('[data-panniversary-seconds]')
    };
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');
    const renderCountdown = () => {
      let remaining = Math.max(0, target - Date.now());
      const days = Math.floor(remaining / 86400000);
      remaining %= 86400000;
      const hours = Math.floor(remaining / 3600000);
      remaining %= 3600000;
      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      values.days.textContent = pad(days);
      values.hours.textContent = pad(hours);
      values.minutes.textContent = pad(minutes);
      values.seconds.textContent = pad(seconds);
    };
    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  });

  const initPanniversaryCreatorWall = (wall) => {
    if (wall.dataset.creatorWallReady === 'true') return;
    wall.dataset.creatorWallReady = 'true';

    wall.querySelectorAll('[data-panniversary-creator-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const dialog = wall.querySelector(`#${trigger.dataset.panniversaryCreatorOpen}`);
        if (dialog && !dialog.open) {
          dialog.showModal();
          dialog.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
        }
      });
    });

    wall.querySelectorAll('[data-panniversary-creator-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => trigger.closest('[data-panniversary-creator-dialog]').close());
    });

    wall.querySelectorAll('[data-panniversary-creator-dialog]').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => dialog.querySelectorAll('video').forEach((video) => video.pause()));
    });
  };

  document.querySelectorAll('[data-panniversary-creator-wall]').forEach(initPanniversaryCreatorWall);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-panniversary-creator-wall]').forEach(initPanniversaryCreatorWall));

  const initPanniversarySubmissionDialog = (dialog) => {
    if (dialog.dataset.submissionDialogReady === 'true') return;
    dialog.dataset.submissionDialogReady = 'true';

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('ugc_submitted') !== '1') return;

    dialog.addEventListener('close', () => {
      searchParams.delete('ugc_submitted');
      const query = searchParams.toString();
      const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', cleanUrl);
    }, { once: true });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    if (!dialog.open) dialog.showModal();
  };

  document.querySelectorAll('[data-panniversary-submission-dialog]').forEach(initPanniversarySubmissionDialog);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-panniversary-submission-dialog]').forEach(initPanniversarySubmissionDialog));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pizzannu-creator-notes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const imageTrigger = event.target.closest('[data-creator-note-image-open]');
    if (imageTrigger) {
      const dialog = imageTrigger.parentElement.querySelector('[data-creator-note-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeTrigger = event.target.closest('[data-creator-note-image-close]');
    if (closeTrigger) {
      const dialog = closeTrigger.closest('[data-creator-note-dialog]');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.matches('[data-creator-note-dialog]')) event.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pizzannu-creator-wall"] && !Shopify.designMode) return;
  try {
    
  const initCreatorWall = (root) => {
    if (root.dataset.creatorWallReady === 'true') return;
    root.dataset.creatorWallReady = 'true';

    root.querySelectorAll('[data-creator-wall-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const dialog = root.querySelector(`#${trigger.dataset.creatorWallOpen}`);
        if (dialog && !dialog.open) dialog.showModal();
      });
    });

    root.querySelectorAll('[data-creator-wall-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => trigger.closest('[data-creator-wall-dialog]').close());
    });

    root.querySelectorAll('[data-creator-wall-dialog]').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  };

  document.querySelectorAll('[data-creator-wall]').forEach(initCreatorWall);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-creator-wall]').forEach(initCreatorWall));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pizzannu-video-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupVideoShowcases = (root = document) => {
      root.querySelectorAll('[data-pizzannu-video-showcase]').forEach((section) => {
        if (section.dataset.videoShowcaseReady === 'true') return;
        section.dataset.videoShowcaseReady = 'true';

        const items = Array.from(section.querySelectorAll('[data-pizzannu-video-item]'));
        const videos = items.map((item) => item.querySelector('video')).filter(Boolean);
        if (!videos.length) return;

        const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
        if (isMobile) {
          videos.forEach((video) => {
            video.controls = false;
            video.removeAttribute('controls');
            video.disablePictureInPicture = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.setAttribute('aria-hidden', 'true');
            video.tabIndex = -1;
            video.addEventListener('contextmenu', (event) => event.preventDefault());
          });
        }

        const setVideoState = (video, isPlaying) => {
          const item = video.closest('[data-pizzannu-video-item]');
          if (!item) return;

          const poster = item.querySelector('[data-video-poster]');
          if (poster) poster.classList.toggle('is-hidden', isPlaying);

          const button = item.querySelector('[data-video-toggle]');
          if (!button) return;

          button.classList.toggle('is-playing', isPlaying);
          button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          const label = button.querySelector('[data-video-toggle-label]');
          if (label) label.textContent = isPlaying ? 'Pause video' : 'Play video';
        };

        videos.forEach((video) => {
          video.addEventListener('playing', () => setVideoState(video, true));
          video.addEventListener('pause', () => setVideoState(video, false));
          video.addEventListener('ended', () => setVideoState(video, false));
        });

        section.querySelectorAll('[data-video-toggle]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (window.matchMedia('(max-width: 767.98px)').matches) return;

            const video = button.closest('[data-pizzannu-video-item]')?.querySelector('video');
            if (!video) return;

            if (video.paused || video.ended) {
              videos.forEach((otherVideo) => {
                if (otherVideo !== video) otherVideo.pause();
              });
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        const track = section.querySelector('[data-pizzannu-video-track]');
        const scrollHint = section.querySelector('[data-pizzannu-video-scroll-hint]');
        if (track && scrollHint) {
          const updateScrollHint = () => {
            const hasOverflow = track.scrollWidth > track.clientWidth + 8;
            const isAtEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
            scrollHint.hidden = !hasOverflow || isAtEnd;
          };

          track.addEventListener('scroll', updateScrollHint, { passive: true });
          scrollHint.addEventListener('click', () => {
            const firstItem = items[0];
            if (!firstItem) return;

            const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
            const scrollDistance = firstItem.getBoundingClientRect().width + gap;
            track.scrollBy({ left: scrollDistance, behavior: 'smooth' });
          });
          updateScrollHint();
        }

        if (!isMobile || !('IntersectionObserver' in window)) return;

        const visibility = new Map(videos.map((video) => [video, 0]));
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });

          const activeVideo = videos.reduce((bestVideo, video) => {
            return !bestVideo || visibility.get(video) > visibility.get(bestVideo) ? video : bestVideo;
          }, null);

          if (!activeVideo || visibility.get(activeVideo) < 0.65) {
            videos.forEach((video) => video.pause());
            return;
          }

          videos.forEach((video) => {
            if (video !== activeVideo) video.pause();
          });
          activeVideo.play().catch(() => {});
        }, { threshold: [0, 0.65, 0.9] });

        videos.forEach((video) => observer.observe(video));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupVideoShowcases(), { once: true });
    } else {
      setupVideoShowcases();
    }
    document.addEventListener('shopify:section:load', (event) => setupVideoShowcases(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
